export default __webpack_public_path__ + "static/media/SmartBiology-Education-Animation-Cell-Looping-Video-Bit-30-VF.454ab688.mp4";